import { UserManager, UserManagerSettings } from 'oidc-client-ts';

import featureFlagManagerForInitialization from './initializationFeatureFlags';

const rawAuthority =
  import.meta.env.VITE_KEYCLOAK_URL ??
  'http://localhost:8080/realms/google-workspace';
// Support both base URL and full /realms/<realm> authority
const authorityMatch = rawAuthority.match(/^(.+)\/realms\/([^/]+)\/?$/);
const authority = authorityMatch
  ? `${authorityMatch[1]}/realms/${authorityMatch[2]}`
  : rawAuthority;

const baseConfig: UserManagerSettings = {
  authority: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080/',
  client_id:
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'spvcockpit-login-service',
  redirect_uri: window.location.origin,
};

const userConfigWithSso: UserManagerSettings = {
  ...baseConfig,
  authority,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: window.location.origin,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-check-sso.html`,
  includeIdTokenInSilentRenew: true,
};

const UserManagerClientWithoutSso = new UserManager(baseConfig);
const UserManagerClientWithSso = new UserManager(userConfigWithSso);

const UserManagerClient =
  featureFlagManagerForInitialization.getIsKeycloakLoginWithSso()
    ? UserManagerClientWithSso
    : UserManagerClientWithoutSso;

export default UserManagerClient;
